<template>
  <DefaultLayout>
    <div class="page-header">
      <h1>Dashboard</h1>
      <p class="subtitle">Resumen de uso de tokens y actividad</p>
    </div>

    <div class="stats-grid">
      <Card>
        <template #content>
          <div class="stat-item">
            <i class="pi pi-bolt stat-icon" />
            <div>
              <div class="stat-value">{{ balance.tokens_used?.toLocaleString() ?? '—' }}</div>
              <div class="stat-label">Tokens usados</div>
            </div>
          </div>
        </template>
      </Card>

      <Card>
        <template #content>
          <div class="stat-item">
            <i class="pi pi-check-circle stat-icon green" />
            <div>
              <div class="stat-value">
                {{ balance.is_unlimited ? '∞' : balance.tokens_remaining?.toLocaleString() ?? '—' }}
              </div>
              <div class="stat-label">Tokens restantes</div>
            </div>
          </div>
        </template>
      </Card>

      <Card>
        <template #content>
          <div class="stat-item">
            <i class="pi pi-android stat-icon purple" />
            <div>
              <div class="stat-value">{{ agents.length }}</div>
              <div class="stat-label">Agentes activos</div>
            </div>
          </div>
        </template>
      </Card>
    </div>

    <Card class="mt-4">
      <template #title>Agentes disponibles</template>
      <template #content>
        <AgentList :agents="agents" @chat="goToChat" />
      </template>
    </Card>
  </DefaultLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import DefaultLayout from '../components/layout/DefaultLayout.vue';
import AgentList from '../components/agents/AgentList.vue';
import Card from 'primevue/card';
import { agentsService } from '../services/agents';
import { tokensService } from '../services/tokens';

const router = useRouter();
const authStore = useAuthStore();
const agents = ref([]);
const balance = ref({});

const goToChat = (agentId) => router.push(`/chat/${agentId}`);

onMounted(async () => {
  try {
    agents.value = await agentsService.getAgents();
    if (authStore.user?.tenant_id) {
      balance.value = await tokensService.getTokenUsage(authStore.user.tenant_id);
    }
  } catch (e) {
    console.error(e);
  }
});
</script>

<style scoped>
.page-header { margin-bottom: 1.5rem; }
.page-header h1 { margin-bottom: 0.25rem; color: #1e293b; }
.subtitle { color: #6b7280; }
.stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; }
.stat-item { display: flex; align-items: center; gap: 1rem; }
.stat-icon { font-size: 2rem; color: #6366f1; }
.stat-icon.green { color: #10b981; }
.stat-icon.purple { color: #8b5cf6; }
.stat-value { font-size: 1.5rem; font-weight: 700; color: #1e293b; }
.stat-label { color: #6b7280; font-size: 0.875rem; }
.mt-4 { margin-top: 1.5rem; }
</style>
